<template>
  <div class="editPreInfo">
    <el-card>
      <div class="jump-btn">
      </div>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
        <el-form-item :label="$t('lang.lab_phoneNum')" prop="mobile">
          <el-input v-model="ruleForm.mobile" @input="keyMobile" :placeholder="$t('lang.lab_selectPhoneNum')"
            class="item-input" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_realName')" prop="name">
          <el-input v-model="ruleForm.name" :placeholder="$t('lang.lab_selectName')" class="item-input" maxlength="50">
          </el-input>
        </el-form-item>        
        <el-form-item :label="$t('lang.lab_theVillage')" prop="gardenId">
          <el-select v-model="ruleForm.gardenId" :placeholder="$t('lang.lab_selectVillage')" @change="selectHouse">
            <el-option v-for="(item, index) in garden" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用虚拟房屋信息" prop="isReal">
						<el-radio-group v-model="ruleForm.isReal">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
        <el-form-item :label="$t('lang.lab_theBuildingNum')" prop="houseId" v-if="this.ruleForm.isReal===0">
          <el-select v-model="ruleForm.houseId" :placeholder="$t('lang.lab_selectBuildingNum')" @change="selectUnit">
            <el-option key :label="$t('lang.lab_selectBuildingNum')" value=""></el-option>
            <el-option v-for="(item, index) in houses" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_theUnitNum')" prop="unitId" v-if="this.ruleForm.isReal===0">
          <el-select v-model="ruleForm.unitId" :placeholder="$t('lang.lab_selectUnitNum')" @change="selectRoom">
            <el-option key :label="$t('lang.lab_selectUnitNum')" value=""></el-option>
            <el-option v-for="(item, index) in units" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_theRoomNum')" prop="roomId" v-if="this.ruleForm.isReal===0">
          <el-select v-model="ruleForm.roomId" :placeholder="$t('lang.lab_selectRoomNum')">
            <el-option key :label="$t('lang.lab_selectRoomNum')" value=""></el-option>
            <el-option v-for="(item, index) in rooms" :key="index" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_preHouseholdID')" prop="idNo">
          <el-input v-model.trim="ruleForm.idNo" :placeholder="$t('lang.lab_selectID')" class="item-input"
            maxlength="100">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('lang.lab_theAddress')" prop="address">
          <el-input v-model="ruleForm.address" :placeholder="$t('lang.lab_selectAddress')" class="item-input"
            maxlength="255"></el-input>
        </el-form-item>        
        <!-- 沟通记录上传 -->
        <el-form-item label="沟通记录管理" v-if="this.isFlag">
          <el-button @click="showGtjlupDialog" type="primary" icon="el-icon-upload">上传</el-button>
          <el-button @click="showGtjldelDialog" type="warning" icon="el-icon-s-order" v-if="gtjlTableData.length>0">详情
          </el-button>
        </el-form-item>

        <!-- 沟通记录上传弹窗 -->
        <el-dialog title="沟通记录上传" :visible.sync="dialogVisible" :close-on-click-modal="false" @close='gtjlClose' center
          top="130px" width="1000px">
          <el-form class="gtjl" :model="gtjlForm" ref="gtjlForm" style="width: 90%;"
            :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
            <el-form-item label="备注" prop="remark" class="editor-width">
              <el-input type="textarea" v-model="gtjlForm.remark" :rows="2" class="replyCon"></el-input>
            </el-form-item>
            <el-form-item label="图片上传" prop="urls99" ref="urls99" class="editor-width">
              <upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='filesList99' :clears='clears'
                @outputFile="getFile99" @removeFile='removeFile99'></upload-morefile>
            </el-form-item>
          </el-form>
          <el-button style="position:relative;left:47%;" type="primary" @click="gtjlupSave('gtjlForm')">
            {{$t('lang.btn_save')}}</el-button>
        </el-dialog>
        <!-- 沟通记录删除弹窗 -->
        <el-dialog title="沟通记录详情" :visible.sync="dialogVisible1" :close-on-click-modal="false" @close='gtjlClose1'
          center top="130px" width="1000px">
          <el-table :data="gtjlTableData" border style="width: 100%">
            <el-table-column prop="remark" label="备注" width="240">
            </el-table-column>
            <el-table-column prop="url" label="图片">
              <template slot-scope="scope">
                <span v-for="(item,index) in scope.row.url.split(',')" :key="index" style="display:inline-block;">
                  <viewer :images="item.split(',')" class="img-width">
                    <img :src="item" class="img">
                  </viewer>
                </span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click.native.prevent="delGtjl(scope.row)" type="text">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-dialog>        

        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" type="primary" @click="saveCar('ruleForm')">
          {{$t('lang.btn_save')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:editPreInfo
   *@Description:原始住户数据管理-编辑/新增
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-03-13
   */
  import {
    mapGetters
  } from 'vuex'
  import uploadmoreFiles from '../../../components/upload_morefiles.vue'
  import uploadmoreFile from '../../../components/upload_morefile.vue'
  export default {
    data() {
      return {
        gtjlLabel: '沟通记录上传/下载' + '\xa0\xa0\xa0',
        rules: {
          mobile: [{
              required: true,
              message: this.$i18n.t('lang.lab_selectPhoneNum'),
              trigger: 'blur'
            },
            {
              pattern: /^-?\d+\.?\d*$/,
              required: true,
              message: this.$i18n.t('lang.lab_phoneNumIsNum'),
              trigger: 'blur'
            }
          ],
          name: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectName'),
            trigger: 'blur'
          }],
          idNo: [{
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            required: false,
            message: this.$i18n.t('lang.lab_isIllegality_ID'),
            trigger: 'blur'
          }],
          gardenId: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectVillage'),
            trigger: 'change'
          }],
         houseId: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectBuildingNum'),
            trigger: 'change'
          }],
          unitId: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectUnitNum'),
            trigger: 'change'
          }],
          roomId: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectRoomNum'),
            trigger: 'change'
          }], 
        },
        activeName: '1',

        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        gardens: [], // 全部小区
        garden: [], // 所选小区
        houses: [], //  存储根据小区请求回来的楼号
        units: [], //  存储根据楼号请求回来的单元
        rooms: [], //  存储根据单元请求回来的房间号
        accept: '*.*',
        clears: false, // 清空按钮
        fileList: [], // 图片上传
        filesList: [],
        fileList3: [], // 文件列表
        filesList3: [],
        fileList4: [], // 文件列表
        filesList4: [],
        fileList5: [], // 文件列表
        filesList5: [],
        fileList6: [], // 文件列表
        filesList6: [],
        fileList7: [], // 文件列表
        filesList7: [],
        fileList8: [], // 文件列表
        filesList8: [],
        fileList9: [], // 文件列表
        filesList9: [],
        fileList10: [], // 文件列表
        filesList10: [],
        fileList99: [],
        filesList99: [],
        ruleForm: {
          address: '', // 地址
          area: 0,
          buildArea: 0, // 建筑面积
          cityId: '',
          isReal: 1,
          deliveryTime: '', // 交付日期
          gardenId: '', // 小区
          houseId: '', // 楼号
          id: '', // id
          idNo: '', // 身份证号
          isDelete: '',
          key: '', // 关键词
          mobile: '', // 手机号码
          mobileLast: '',
          name: '', // 名字
          no: 0,
          operateId: '',
          order: '',
          page: '',
          pageSize: '', // 每页显示数量
          propertyFee: 0,
          roomId: '', // 房间号
          sort: '',
          unitId: '', // 单元号
          urls: [], // 上传图片
          urls3: [], // 上传图片
          urls4: [], // 上传图片
          urls5: [], // 上传图片
          urls6: [], // 上传图片
          urls7: [], // 上传图片
          urls8: [], // 上传图片
          urls9: [], // 上传图片
          urls10: [], // 上传图片
          phones: '', // 备用电话
        },
        dialogVisible: false,
        dialogVisible1: false,
        gtjlForm: {
          remark: '', // 沟通记录备注
          url: '', // 沟通记录图片
        },
        gtjlTableData: [], // 沟通记录详情数据
      }
    },
    components: {
      'upload-morefiles': uploadmoreFiles,
      'upload-morefile': uploadmoreFile
    },
    destroyed() {
      // window.localStorage.setItem('editPreInfoForm', JSON.stringify(this.ruleForm))
      // window.localStorage.setItem('editPreInfoSaveData', JSON.stringify(this.saveData))
    },
    created() {
      this.ruleForm.gardenId = this.gardenId
      // 获取小区
      this.selectGarden()
      // 获取楼号下拉候选
      this.gardenGrids(1, this.gardenId)
     
      this.ruleForm.houseId = ''
      this.ruleForm.unitId = ''
      this.ruleForm.roomId = ''
    },
    computed: {
      ...mapGetters(['gardenId'])
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      },
      gardenId: function (newFlag, oldFlag) {
        this.ruleForm.gardenId = this.gardenId
        // 获取小区
        this.selectGarden()
        // 获取楼号下拉候选
        this.selectHouse(this.gardenId)
      },
    },
    methods: {
      handleClick(tab, event) {
        console.log(tab, event)
      },
      // 获取组件值
      getFile(e, f) {
        this.isDisabled = false
        this.fileList.push({
          name: f,
          url: e
        })
      },
      getFile3(e, f) {
        this.isDisabled = false
        this.fileList3.push({
          name: f,
          url: e
        })
      },
      getFile4(e, f) {
        this.isDisabled = false
        this.fileList4.push({
          name: f,
          url: e
        })
      },
      getFile5(e, f) {
        this.isDisabled = false
        this.fileList5.push({
          name: f,
          url: e
        })
      },
      getFile6(e, f) {
        this.isDisabled = false
        this.fileList6.push({
          name: f,
          url: e
        })
      },
      getFile7(e, f) {
        this.isDisabled = false
        this.fileList7.push({
          name: f,
          url: e
        })
      },
      getFile8(e, f) {
        this.isDisabled = false
        this.fileList8.push({
          name: f,
          url: e
        })
      },
      getFile9(e, f) {
        this.isDisabled = false
        this.fileList9.push({
          name: f,
          url: e
        })
      },
      getFile10(e, f) {
        console.log(e)
        console.log(f)
        this.isDisabled = false
        this.fileList10.push({
          name: f,
          url: e
        })
      },
      getFile99(e) {
        console.log(e)
        this.fileList99.push(e)
      },
      // 移除图片
      removeFile(e) {
        let list1 = []
        for (let i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url === e) {

          } else {
            list1.push(this.fileList[i])
          }
        }
        this.fileList = list1
        this.filesList = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      // 移除图片
      removeFile3(e) {
        let list1 = []
        for (let i = 0; i < this.fileList3.length; i++) {
          if (this.fileList3[i].url === e) {

          } else {
            list1.push(this.fileList3[i])
          }
        }
        this.fileList3 = list1
        this.filesList3 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      // 移除图片
      removeFile4(e) {
        let list1 = []
        for (let i = 0; i < this.fileList4.length; i++) {
          if (this.fileList4[i].url === e) {

          } else {
            list1.push(this.fileList4[i])
          }
        }
        this.fileList4 = list1
        this.filesList4 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      // 移除图片
      removeFile5(e) {
        let list1 = []
        for (let i = 0; i < this.fileList5.length; i++) {
          if (this.fileList5[i].url === e) {

          } else {
            list1.push(this.fileList5[i])
          }
        }
        this.fileList5 = list1
        this.filesList5 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      // 移除图片
      removeFile6(e) {
        let list1 = []
        for (let i = 0; i < this.fileList6.length; i++) {
          if (this.fileList6[i].url === e) {

          } else {
            list1.push(this.fileList6[i])
          }
        }
        this.fileList6 = list1
        this.filesList6 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      removeFile7(e) {
        let list1 = []
        for (let i = 0; i < this.fileList7.length; i++) {
          if (this.fileList7[i].url === e) {

          } else {
            list1.push(this.fileList7[i])
          }
        }
        this.fileList7 = list1
        this.filesList7 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      removeFile8(e) {
        let list1 = []
        for (let i = 0; i < this.fileList8.length; i++) {
          if (this.fileList8[i].url === e) {

          } else {
            list1.push(this.fileList8[i])
          }
        }
        this.fileList8 = list1
        this.filesList8 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      removeFile9(e) {
        let list1 = []
        for (let i = 0; i < this.fileList9.length; i++) {
          if (this.fileList9[i].url === e) {

          } else {
            list1.push(this.fileList9[i])
          }
        }
        this.fileList9 = list1
        this.filesList9 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      removeFile10(e) {
        let list1 = []
        for (let i = 0; i < this.fileList10.length; i++) {
          if (this.fileList10[i].url === e) {

          } else {
            list1.push(this.fileList10[i])
          }
        }
        this.fileList10 = list1
        this.filesList10 = JSON.parse(JSON.stringify(list1))
        this.isDisabled = false
      },
      removeFile99(e) {
        console.log(e)
        let list1 = []
        for (let i = 0; i < this.fileList99.length; i++) {
          if (this.fileList99[i] === e) {} else {
            list1.push(this.fileList99[i])
          }
        }
        this.fileList99 = list1
        // this.filesList99 = JSON.parse(JSON.stringify(list1))
      },
      // 原始住户数据管理编辑页面获取数据
      getData() {
        // 这是用来双向绑定
        this.ruleForm = this.$route.query.object
        console.log(this.ruleForm)
        this.ruleForm.idNo = (this.ruleForm.idNo).trim()
        this.filesList = []
        this.fileList = []
        if (this.$route.query.object.urls && this.$route.query.object.urls.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls.length; i++) {
            this.filesList.push({
              name: this.$route.query.object.urls[i].split('|')[1],
              url: this.$route.query.object.urls[i].split('|')[0]
            })
            this.fileList.push({
              name: this.$route.query.object.urls[i].split('|')[1],
              url: this.$route.query.object.urls[i].split('|')[0]
            })
          }
        }
        this.filesList3 = []
        this.fileList3 = []
        if (this.$route.query.object.urls3 && this.$route.query.object.urls3.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls3.length; i++) {
            this.filesList3.push({
              name: this.$route.query.object.urls3[i].split('|')[1],
              url: this.$route.query.object.urls3[i].split('|')[0]
            })
            this.fileList3.push({
              name: this.$route.query.object.urls3[i].split('|')[1],
              url: this.$route.query.object.urls3[i].split('|')[0]
            })
          }
        }
        this.filesList4 = []
        this.fileList4 = []
        if (this.$route.query.object.urls4 && this.$route.query.object.urls4.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls4.length; i++) {
            this.filesList4.push({
              name: this.$route.query.object.urls4[i].split('|')[1],
              url: this.$route.query.object.urls4[i].split('|')[0]
            })
            this.fileList4.push({
              name: this.$route.query.object.urls4[i].split('|')[1],
              url: this.$route.query.object.urls4[i].split('|')[0]
            })
          }
        }
        this.filesList5 = []
        this.fileList5 = []
        if (this.$route.query.object.urls5 && this.$route.query.object.urls5.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls5.length; i++) {
            this.filesList5.push({
              name: this.$route.query.object.urls5[i].split('|')[1],
              url: this.$route.query.object.urls5[i].split('|')[0]
            })
            this.fileList5.push({
              name: this.$route.query.object.urls5[i].split('|')[1],
              url: this.$route.query.object.urls5[i].split('|')[0]
            })
          }
        }
        this.filesList6 = []
        this.fileList6 = []
        if (this.$route.query.object.urls6 && this.$route.query.object.urls6.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls6.length; i++) {
            this.filesList6.push({
              name: this.$route.query.object.urls6[i].split('|')[1],
              url: this.$route.query.object.urls6[i].split('|')[0]
            })
            this.fileList6.push({
              name: this.$route.query.object.urls6[i].split('|')[1],
              url: this.$route.query.object.urls6[i].split('|')[0]
            })
          }
        }
        this.filesList7 = []
        this.fileList7 = []
        if (this.$route.query.object.urls7 && this.$route.query.object.urls7.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls7.length; i++) {
            this.filesList7.push({
              name: this.$route.query.object.urls7[i].split('|')[1],
              url: this.$route.query.object.urls7[i].split('|')[0]
            })
            this.fileList7.push({
              name: this.$route.query.object.urls7[i].split('|')[1],
              url: this.$route.query.object.urls7[i].split('|')[0]
            })
          }
        }
        this.filesList8 = []
        this.fileList8 = []
        if (this.$route.query.object.urls8 && this.$route.query.object.urls8.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls8.length; i++) {
            this.filesList8.push({
              name: this.$route.query.object.urls8[i].split('|')[1],
              url: this.$route.query.object.urls8[i].split('|')[0]
            })
            this.fileList8.push({
              name: this.$route.query.object.urls8[i].split('|')[1],
              url: this.$route.query.object.urls8[i].split('|')[0]
            })
          }
        }
        this.filesList9 = []
        this.fileList9 = []
        if (this.$route.query.object.urls9 && this.$route.query.object.urls9.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls9.length; i++) {
            this.filesList9.push({
              name: this.$route.query.object.urls9[i].split('|')[1],
              url: this.$route.query.object.urls9[i].split('|')[0]
            })
            this.fileList9.push({
              name: this.$route.query.object.urls9[i].split('|')[1],
              url: this.$route.query.object.urls9[i].split('|')[0]
            })
          }
        }
        this.filesList10 = []
        this.fileList10 = []
        if (this.$route.query.object.urls10 && this.$route.query.object.urls10.length > 0) {
          for (let i = 0; i < this.$route.query.object.urls10.length; i++) {
            this.filesList10.push({
              name: this.$route.query.object.urls10[i].split('|')[1],
              url: this.$route.query.object.urls10[i].split('|')[0]
            })
            this.fileList10.push({
              name: this.$route.query.object.urls10[i].split('|')[1],
              url: this.$route.query.object.urls10[i].split('|')[0]
            })
          }
        }
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
        this.getGtjlList()
      },
      // 获取小区下拉
      selectGarden() {
        this.$get(`/gardens`).then(
          res => {
            if (res && res.errCode === 0) {
              this.gardens = res.list
              // 所属小区下拉框
              var numGardenId = Number(this.gardenId)
              var objGardenId = this.gardens.find(function (obj) {
                return obj.id === numGardenId
              })
              var newValue = {
                id: objGardenId.id,
                name: objGardenId.name,
              }
              this.garden.push(newValue)
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // id查询楼号楼层房间号
      gardenGrids(type, id) {
        if (id === '') return
        this.$get(`/gardenGrids/?type=${type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (type === 1) {
                this.houses = res.list
              } else if (type === 2) {
                this.units = res.list
              } else if (type === 3) {
                this.rooms = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 根据小区选择获取楼号
      selectHouse(id) {
        this.type = 1
        this.ruleForm.houseId = ''
        this.ruleForm.unitId = ''
        this.ruleForm.roomId = ''
        this.houses = []
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据楼号选择获取单元
      selectUnit(id) {
        this.type = 2
        this.ruleForm.unitId = ''
        this.ruleForm.roomId = ''
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据单元选择获取房间
      selectRoom(id) {
        this.type = 3
        this.rooms = []
        this.ruleForm.roomId = ''
        this.gardenGrids(this.type, id)
      },
      // 返回
      back() {
        this.$router.push({
          name: 'preHouseholdInfoManageList'
        })
      },
      // 保存
      save(formName) {
        let params = {}
        if (this.isFlag) {
          params.Id = this.ruleForm.id
        }
        params.Mobile = this.ruleForm.mobile
        params.Name = this.ruleForm.name
        params.IdNo = this.ruleForm.idNo
        params.Address = this.ruleForm.address
        params.Area = this.ruleForm.area
        params.BuildArea = this.ruleForm.buildArea
        params.Phones = this.ruleForm.phones
        // params.Type = 1 // userType
        if (this.ruleForm.propertyFee === null) {
          this.ruleForm.propertyFee = 0
        }
        params.PropertyFee = this.ruleForm.propertyFee
        params.No = this.ruleForm.no
        params.GardenId = this.ruleForm.gardenId
        params.HouseId = this.ruleForm.houseId
        params.UnitId = this.ruleForm.unitId
        params.RoomId = this.ruleForm.roomId
        if (this.ruleForm.deliveryTime != null && this.ruleForm.deliveryTime != '') {
          params.DeliveryTimeParam = new Date(this.ruleForm.deliveryTime).toString()
        }
        if (this.fileList.length > 0) {
          for (let i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].url.indexOf('blob') != -1) {
              this.filesList.push(this.fileList[i].response.data[0])
            } else {
              this.filesList.push(this.fileList[i].url)
            }
          }
        }
        params.files = this.filesList.toString()
        if (this.fileList3.length > 0) {
          for (let i = 0; i < this.fileList3.length; i++) {
            if (this.fileList3[i].url.indexOf('blob') != -1) {
              this.filesList3.push(this.fileList3[i].response.data[0])
            } else {
              this.filesList3.push(this.fileList3[i].url)
            }
          }
        }
        params.files3 = this.filesList3.toString()
        if (this.fileList4.length > 0) {
          for (let i = 0; i < this.fileList4.length; i++) {
            if (this.fileList4[i].url.indexOf('blob') != -1) {
              this.filesList4.push(this.fileList4[i].response.data[0])
            } else {
              this.filesList4.push(this.fileList4[i].url)
            }
          }
        }
        params.files4 = this.filesList4.toString()
        if (this.fileList5.length > 0) {
          for (let i = 0; i < this.fileList5.length; i++) {
            if (this.fileList5[i].url.indexOf('blob') != -1) {
              this.filesList5.push(this.fileList5[i].response.data[0])
            } else {
              this.filesList5.push(this.fileList5[i].url)
            }
          }
        }
        params.files5 = this.filesList5.toString()
        if (this.fileList6.length > 0) {
          for (let i = 0; i < this.fileList6.length; i++) {
            if (this.fileList6[i].url.indexOf('blob') != -1) {
              this.filesList6.push(this.fileList6[i].response.data[0])
            } else {
              this.filesList6.push(this.fileList6[i].url)
            }
          }
        }
        params.files6 = this.filesList6.toString()
        if (this.fileList7.length > 0) {
          for (let i = 0; i < this.fileList7.length; i++) {
            if (this.fileList7[i].url.indexOf('blob') != -1) {
              this.filesList7.push(this.fileList7[i].response.data[0])
            } else {
              this.filesList7.push(this.fileList7[i].url)
            }
          }
        }
        params.files7 = this.filesList7.toString()
        if (this.fileList8.length > 0) {
          for (let i = 0; i < this.fileList8.length; i++) {
            if (this.fileList8[i].url.indexOf('blob') != -1) {
              this.filesList8.push(this.fileList8[i].response.data[0])
            } else {
              this.filesList8.push(this.fileList8[i].url)
            }
          }
        }
        params.files8 = this.filesList8.toString()
        if (this.fileList9.length > 0) {
          for (let i = 0; i < this.fileList9.length; i++) {
            if (this.fileList9[i].url.indexOf('blob') != -1) {
              this.filesList9.push(this.fileList9[i].response.data[0])
            } else {
              this.filesList9.push(this.fileList9[i].url)
            }
          }
        }
        params.files9 = this.filesList9.toString()
        if (this.fileList10.length > 0) {
          for (let i = 0; i < this.fileList10.length; i++) {
            if (this.fileList10[i].url.indexOf('blob') != -1) {
              this.filesList10.push(this.fileList10[i].response.data[0])
            } else {
              this.filesList10.push(this.fileList10[i].url)
            }
          }
        }
        params.files10 = this.filesList10.toString()
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let loading = this.$loading()
            if (this.isFlag) {
              this.$post(`roomOwner/update`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_modify_success'))
                    var index = this.$keepAlive.indexOf('/manage/main.roomOwner')
                    if (index > -1) {
                      this.$keepAlive.splice(index, 1)
                    }
                    this.$router.push({
                      name: 'preHouseholdInfoManageList'
                    })
                  }
                  setTimeout(() => {
                    loading.close()
                  }, 200)
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              this.$get(`/roomOwnerByRoomId/` + this.ruleForm.roomId).then(
                res => {
                  loading.close()
                  this.parkList = res.list
                  console.log(this.parkList)
                  if (res.list.length == 0) {
                    this.$post('roomOwner/save', params).then(
                      res => {
                        loading.close()
                        if (res && res.errCode === 0) {
                          this.$message.success(this.$i18n.t('lang.lab_save_success'))
                          var index = this.$keepAlive.indexOf('/manage/main.roomOwner')
                          if (index > -1) {
                            this.$keepAlive.splice(index, 1)
                          }
                          this.$router.push({
                            name: 'preHouseholdInfoManageList'
                          })
                        }
                        setTimeout(() => {
                          loading.close()
                        }, 200)
                      },
                      error => {
                        loading.close()
                        this.$message.error(error)
                      }
                    )
                  } else {
                    loading.close()
                    this.$message.error(this.$i18n.t('此房间已存在业主信息。'))
                  }
                },
                err => {
                  loading.close()
                  this.$message.error(err)
                })
            }
          } else {
            return false
          }
        })
      },
      // 保存业主信息
      saveCar(formName) {
          let params = {}
          params.Mobile = this.ruleForm.mobile
          params.Name = this.ruleForm.name
          params.IdNo = this.ruleForm.idNo
          params.Address = this.ruleForm.address
          params.GardenId = this.ruleForm.gardenId
          params.IsReal = this.ruleForm.isReal
          if (this.ruleForm.isReal === 0) {
            params.HouseId = this.ruleForm.houseId
            params.UnitId = this.ruleForm.unitId
            params.RoomId = this.ruleForm.roomId
          } else {
            params.HouseId = ''
            params.UnitId = ''
            params.RoomId = ''
          }

          this.$refs[formName].validate((valid) => {
            if (valid) {
              console.log(params)
              let loading = this.$loading()
              this.$post(`roomOwner/saveCar`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_save_success'))
                    this.resetForm(formName)
                  }
                  setTimeout(() => {
                    loading.close()
                  }, 200)
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              return false
            }
          })          
      },
      // 清空
      resetForm(formName) {
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.address = ''
        this.ruleForm.area = 0
        this.ruleForm.buildArea = 0
        this.ruleForm.cityId = ''
        this.ruleForm.deliveryTime = ''
        this.ruleForm.houseId = ''
        this.ruleForm.idNo = ''
        this.ruleForm.isDelete = ''
        this.ruleForm.key = ''
        this.ruleForm.mobile = ''
        this.ruleForm.mobileLast = ''
        this.ruleForm.name = ''
        this.ruleForm.no = 0
        this.ruleForm.operateId = ''
        this.ruleForm.order = ''
        this.ruleForm.propertyFee = 0
        this.ruleForm.roomId = ''
        this.ruleForm.sort = ''
        this.ruleForm.unitId = ''
        // 由于三个下拉联动，清空时需要二次清表单验证
        setTimeout(() => {
          this.$refs.ruleForm.clearValidate()
        }, 0)
      },
      // 建筑面积输入限制
      keyBuildArea() {
        // 仅保留数字和"."
        this.ruleForm.buildArea = this.ruleForm.buildArea.replace(/[^\d.]/g, '')
        // 两个连续的"."仅保留第一个"."
        this.ruleForm.buildArea = this.ruleForm.buildArea.replace(/\.{2,}/g, '.')
        // 去除其他"."
        this.ruleForm.buildArea = this.ruleForm.buildArea.replace('.', '$#*').replace(/\./g, '').replace('$#*', '.')
        // 限制只能输入两个小数
        // this.ruleForm.buildArea = this.ruleForm.buildArea.replace(/^(\d+)\.(\d\d).*$/, '$1.$2') 
        // 首位是0的话去掉
        if (this.ruleForm.buildArea.indexOf('.') < 0 && this.ruleForm.buildArea != '') {
          this.ruleForm.buildArea = parseFloat(this.ruleForm.buildArea)
        }
      },
      // 手机号码输入限制
      keyMobile() {
        // 仅保留数字
        this.ruleForm.mobile = this.ruleForm.mobile.replace(/[^\d]/g, '')
      },
      // 沟通记录上传弹窗显示
      showGtjlupDialog() {
        this.dialogVisible = true
      },
      // 沟通记录删除弹窗显示
      showGtjldelDialog() {
        this.dialogVisible1 = true
      },
      // 沟通记录上传保存
      gtjlupSave(formName) {
        this.gtjlForm.url = this.fileList99.join(',')
        if (this.gtjlForm.remark == '') {
          this.$message.error('请输入沟通记录备注')
          return false
        }
        if (this.gtjlForm.url == '') {
          this.$message.error('请上传沟通记录图片')
          return false
        }
        let params = {}
        params.ownerId = this.ruleForm.id
        params.remark = this.gtjlForm.remark
        params.urls = this.gtjlForm.url
        console.log(params)
        this.$post(`insertDrawImage`, params).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.$message.success('保存成功')
              this.dialogVisible = false
              this.getGtjlList()
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      gtjlClose() {
        this.gtjlForm.remark = ''
        this.gtjlForm.url = ''
        this.filesList99 = []
        this.fileList99 = []
      },
      gtjlClose1() {
        this.getGtjlList()
      },
      // 获取沟通记录数据列表
      getGtjlList() {
        this.$get(`/selectDrawImage?ownerId=${this.ruleForm.id}`).then(
          res => {
            if (res && res.errCode === 0) {
              console.log(res)
              this.gtjlTableData = res.list.length > 0 ? res.list.reverse() : res.list
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 删除沟通记录
      delGtjl(row) {
        console.log(row)
        let loading = this.$loading()
        let params = {
          fileGroup: row.fileGroup
        }
        this.$confirm(this.$i18n.t('lang.lab_isdelete'), this.$i18n.t('lang.lab_prompt'), {
            confirmButtonText: this.$i18n.t('lang.btn_confirm'),
            cancelButtonText: this.$i18n.t('lang.btn_cancel'),
            type: 'warning'
          }).then(() => {
            this.$post(`/deleteDrawImage`, params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message({
                    type: 'success',
                    message: this.$i18n.t('lang.lab_del_success')
                  })
                  this.getGtjlList()
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          })
          .catch(() => {
            loading.close()
            this.$message({
              type: 'info',
              message: this.$i18n.t('lang.lab_del_can')
            })
          })
      }
    }
  }
</script>

<style lang='scss'>
  .editPreInfo {
    .item-input {
      width: 30%;
    }

    .el-upload-list,
    .el-upload-list--picture {
      display: flex;
      flex-wrap: wrap !important;
      // overflow: hidden!important;
      // text-overflow: ellipsis!important;
      // -webkit-line-clamp: 3!important;
      // -webkit-box-orient: vertical!important;
      // line-height: 1.5!important;
      // white-space: normal!important;
    }

    .el-upload-list__item-name {
      margin-top: 0 !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      -webkit-line-clamp: 3 !important;
      -webkit-box-orient: vertical !important;
      line-height: 1.6 !important;
      white-space: normal !important;
      display: -webkit-box !important;
      word-wrap: break-word !important;
    }

    .el-upload-list__item {
      // width: auto;
      max-width: 300px;
      margin-right: 20px;
    }

    .el-tabs {
      background-color: #fff !important;
    }

    .el-tabs__nav-wrap {
      width: 100% !important;
      max-width: 100% !important;
      position: static !important;
      background-color: #fff !important;
      padding-left: 35px !important;
      margin-bottom: 20px !important;
      box-sizing: border-box;
    }

    .el-tabs__content {
      background-color: #fff !important;
    }

    .el-tabs__item.is-top:last-child {
      padding-right: 15px !important;
    }

    .el-form-item__label {
      width: 160px !important;
    }

    .gtjl .el-form-item__label {
      width: 100px !important;
    }

    // .el-tabs__nav-scroll .el-tabs__nav.is-top .el-tabs__item{
    //   border-right: none !important;
    // }
    .el-tabs__active-bar {
      left: 3px;
    }
  }

  .img {
    width: 80px;
    height: 80px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
    margin: 0 5px;
  }

  .img-width {
    display: flex;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 320px;
  }
</style>